import { useEffect, useState } from "react";
import { adminApi, fmtDate } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function AdminLeads({ adminKey }) {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const { data } = await adminApi(adminKey).get("/admin/leads");
        setLeads(data);
      } catch { toast.error("Failed to load leads"); }
      finally { setLoading(false); }
    };
    load();
  }, [adminKey]);

  return (
    <div className="px-6 md:px-10 py-10 max-w-6xl mx-auto">
      <div className="mb-10">
        <p className="overline mb-2">Pipeline</p>
        <h1 className="font-display text-5xl tracking-tighter">All Leads</h1>
      </div>

      <div className="border border-foreground bg-white">
        {loading ? (
          <div className="p-10 text-muted-foreground">Loading…</div>
        ) : leads.length === 0 ? (
          <div className="p-10 text-muted-foreground font-display text-xl text-center">
            No leads yet.
          </div>
        ) : (
          <ul className="divide-y divide-border" data-testid="leads-list">
            {leads.map((l) => (
              <li key={l.id} className="px-6 py-5 flex items-start justify-between gap-6">
                <div>
                  <p className="font-display text-2xl">{l.name}</p>
                  <p className="text-sm text-muted-foreground">{l.company}{l.role ? ` · ${l.role}` : ""}</p>
                  <p className="font-mono-data text-xs text-muted-foreground mt-2 flex items-center gap-2">
                    <Mail className="w-3 h-3" /> {l.email}{l.phone ? ` · ${l.phone}` : ""}
                  </p>
                  {l.partner_name && (
                    <p className="font-mono-data text-xs text-primary mt-1">via {l.partner_name} ({l.code})</p>
                  )}
                  {l.message && <p className="mt-3 text-sm italic text-muted-foreground max-w-2xl">"{l.message}"</p>}
                </div>
                <span className="font-mono-data text-xs text-muted-foreground whitespace-nowrap">
                  {fmtDate(l.created_at)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
